import { Palette } from 'config';
import styled from '@emotion/styled';

export const NewAppContainer = styled.span`
  width: 540px;
  display: flex;
  flex-direction: column;
  .MuiTabs-indicator {
    display: none;
  }
  .Mui-selected-style {
    background: ${Palette.Primary._000};
  }
  button.Mui-selected {
    border: 1px solid ${Palette.Primary._300};
    box-shadow: none;
  }
`;
export const TabCenter = {};

export const TabStyle = {
  display: 'flex',
  flex: '0 0 33.333333%',
  width: '33.3333333%',
  padding: '0',
  minHeight: 'auto',
  borderRadius: '0',
  backgroundColor: '#FFF',
  border: `1px solid ${Palette.PrimaryGray._200}`,
  boxShadow: `0px 2px 2px rgba(0, 0, 0, 0.05)`,
};
export const TabFirstChild = {
  borderRadius: '4px 0 0 4px',
};
export const TabLastChild = {
  borderRadius: '0 4px 4px 0',
};
export const TabRoot = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 40px;
  overflow: hidden;
`;
export const TabImage = styled.div`
  width: 22px;
  height: 24px;
  margin-right: 8px;
`;
export const TabText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
  text-align: center;
  white-space: nowrap;
  text-transform: none;
`;

export const StoreTabs = styled.div`
  display: flex;
  width: 100%;

  & > button {
    border-radius: 0;
  }
  & > button:first-child {
    border-radius: 4px 0 0 4px;
  }
  & > button:last-child {
    border-radius: 0 4px 4px 0;
  }
  & > button:only-child {
    border-radius: 4px;
  }
`;

export const PannelsPadding = {
  padding: '0',
};

export const Label = styled.label`
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #334155;
  padding-bottom: 8px;
`;

export const Content = styled.div`
  padding: 0 24px;
`;
